// Traduções comuns - Português (Brasil)
export const commonPt = {
  // Ações gerais
  actions: {
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    view: 'Ver',
    close: 'Fechar',
    next: 'Próximo',
    previous: 'Anterior',
    search: 'Buscar',
    filter: 'Filtrar',
    clear: 'Limpar',
    apply: 'Aplicar',
    contact: 'Entrar em contato',
    send: 'Enviar',
    share: 'Compartilhar',
  },

  // Estados
  states: {
    loading: 'Carregando...',
    error: 'Erro',
    success: 'Sucesso',
    empty: 'Vazio',
    notFound: 'Não encontrado',
  },

  // Formulários
  forms: {
    required: 'Este campo é obrigatório',
    invalidEmail: 'E-mail inválido',
    invalidPhone: 'Número de telefone inválido',
    minLength: 'Mínimo de {min} caracteres',
    maxLength: 'Máximo de {max} caracteres',
  },

  // Moedas e formatos
  currency: {
    clp: 'CLP', // código ISO atrelado à chave `clp`; mantido (chave não usada no site)
    usd: 'USD',
    eur: 'EUR',
  },

  // Unidades
  units: {
    km: 'km',
    miles: 'milhas',
    year: 'ano',
    years: 'anos',
  },
};
